<template>
    <div class="container">
		<div class="cars_title">
			<span>Получите максимальные выгоды</span><br>
			На автомобили Mitsubishi <span class="red-text no-fw">в наличии</span>
		</div>
	</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.container {
    margin: 0px auto;
    max-width: 1140px;
    position: relative;
    padding: 0px 15px;
    text-align: center;
}

.cars_title {
    color: #686d71;
    font-size: 30px;
    font-weight: 400;
    text-transform: uppercase;
    padding-left: 30px;
    border-left: 7px solid #ed0000;
	margin: 70px 0 0 0;

	@media (max-width: 320px) {
		margin: 40px 0 0 0;
	}

	@media (max-width: 380px) {
		font-size: 24px;
	}

	span {
		font-weight: 700;
	}
}
</style>
